import { SafePromise } from '@benzinga/safe-await';
import { StockSymbol } from '@benzinga/session';
import { ChartDataResponse } from '../entities';
import { RestfulClient } from '@benzinga/session';
import { Session } from '@benzinga/session';
import { ChartEnvironment } from '../environment';
import { DateTime } from 'luxon';

export class BarsRestful extends RestfulClient {
  constructor(session: Session) {
    super(session.getEnvironment(ChartEnvironment).barsUrl, session);
  }

  getBars = (
    symbol: StockSymbol,
    params: { to?: string; from?: string; interval?: string },
  ): SafePromise<ChartDataResponse[]> => {
    const to = params.to ? DateTime.fromFormat(params.to, 'yyyy-MM-dd') : undefined;
    const from = params.from ? DateTime.fromFormat(params.from, 'yyyy-MM-dd') : undefined;

    const url = this.URL(`v2/bars`, {
      from: from && from.isValid ? from.toFormat('yyyy-MM-dd') : '',
      interval: params.interval ? params.interval : '5M',
      symbols: symbol,
      to: to && to.isValid ? to.toFormat('yyyy-MM-dd') : undefined,
      token: this.session.getEnvironment(ChartEnvironment).barsKey,
    });
    return this.get(url, {
      allowsAnonymousAuth: true,
      credentials: 'same-origin',
      includeHeader: { authorization: true },
    });
  };
}
